import React from 'react'
import SearchTopBoxAuthor from '../../components/searchtopboxAuthor/SearchTopBoxAuthor'
import SearchTabsEventsSugar from '../../components/searchTabsEventsSugar/SearchTabsEventsSugar'

const SearchService = () => {
  return (
    <div className='dashboard-content-box'>
       <div className='searchbox-header-top'>
        <SearchTopBoxAuthor />
       </div>
       <div className='search-box-bottom  fixed-padding search-tabs-events-sugar'>
          <SearchTabsEventsSugar />
       </div>
    </div>
  )
}

export default SearchService
